import { render, staticRenderFns } from "./CurriculumDetail.vue?vue&type=template&id=50919b62&scoped=true&"
import script from "./CurriculumDetail.vue?vue&type=script&lang=js&"
export * from "./CurriculumDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50919b62",
  null
  
)

export default component.exports